import { css } from 'styled-components';

const modalStyles = css`
  .logout-message-modal {
    padding-bottom: 2rem;
  }
`;

export default modalStyles;
